import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Styles/yellocalfcss/AddArrears.css";

export default function GenerateInvoice() {
  const [grade, setGrade] = useState("");
  const [division, setDivision] = useState("");
  const [year, setYear] = useState("");
  const [term, setTerm] = useState("");
  const isFormValid = grade && division && year && term;

  return (
    <div className="generateinvoice-container mt-3">
      <nav aria-label="breadcrumb">
        <ol className="generateinvoice-breadcrumb bg-light p-2 rounded">
          <li className="generateinvoice-breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li className="generateinvoice-breadcrumb-item">
            <a href="#">Fee Invoice</a>
          </li>
          <li className="generateinvoice-breadcrumb-item active" aria-current="page">
            Generate Arrear Invoice
          </li>
        </ol>
      </nav>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="generateinvoice-text-brown">Generate Arrear Invoice</h4>
        <button className="generateinvoice-btn-success">Import arrears</button>
      </div>

      <div className="generateinvoice-card shadow-sm">
        <div className="generateinvoice-card-body">
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="generateinvoice-form-label">Select Grade *</label>
              <select
                className="generateinvoice-form-select"
                value={grade}
                onChange={(e) => setGrade(e.target.value)}
              >
                <option value="">Select Grade</option>
                <option value="Grade 1">felix</option>
                <option value="Grade 2">testtttt</option>
                <option value="Grade 3">10(A)</option>
                <option value="Grade 2">GRADE 6</option>
                <option value="Grade 3">9(A)</option>
                <option value="Grade 2">HARMONIUM1</option>
                <option value="Grade 3">7(A)</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label className="generateinvoice-form-label">Select Division</label>
              <select
                className="generateinvoice-form-select"
                value={division}
                onChange={(e) => setDivision(e.target.value)}
              >
                <option value="">Select Division</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label className="generateinvoice-form-label">Select Academic Year *</label>
              <select
                className="generateinvoice-form-select"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              >
                <option value="">Academic Year</option>
                <option value="2023-24">2023-24</option>
                <option value="2024-25">aaaa</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label className="generateinvoice-form-label">Select Terms/Semester</label>
              <select
                className="generateinvoice-form-select"
                value={term}
                onChange={(e) => setTerm(e.target.value)}
              >
                <option value="">Select Terms/Semester</option>
              </select>
            </div>
          </div>

          <div className="text-end">
            <button className="generateinvoice-btn-primary" disabled={!isFormValid}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
